export default "__VITE_ASSET__DsycS2N3__"